import { forwardRef, type ButtonHTMLAttributes } from "react";

import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "danger";

function variantClass(variant: ButtonVariant, className?: string): string {
  return [styles.btn, styles[variant], className].filter(Boolean).join(" ");
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

/**
 * The one primary/secondary/danger button used everywhere — replaces the
 * independently-authored "primary" buttons that had drifted apart (different
 * font size, weight, padding and hover feedback in Access Management vs the
 * approval Review screen). Defaults to `type="button"` so it never
 * accidentally submits a form.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "secondary", className, type = "button", ...rest },
  ref
) {
  return <button ref={ref} type={type} className={variantClass(variant, className)} {...rest} />;
});
